export function resolveHookState(nextState, prevState) {
    if (typeof nextState === 'function')
        return nextState(prevState);
    return nextState;
}
